import { getTempToWindChill } from '../../utils/stringUtil';

const WEATHER_LABELS = {
    "Sunny": "맑음", "Cloudy": "구름많음", "Overcast": "흐림",
    "Snow": "눈", "Rain": "비", "Shower": "소나기", "Rain/Snow": "비/눈"
};

const WeatherDetail = ({ prefix, state, locationLabel }) => {
    let temp = state[prefix + "Temp"];
    let weather = state[prefix + "Weather"];
    let humidity = state[prefix + "Humidity"];
    let windSpeed = state[prefix + "WindSpeed"];
    let rainRate = state[prefix + "RainRate"];
    let precipitation = state[prefix + "Precipitation"];
    let windChill = temp && windSpeed
        ? getTempToWindChill(parseInt(temp), parseFloat(windSpeed)) : "";

    return (
        <div className='detailPanel'>
            <div className='detailHeader'>{locationLabel}</div>
            <div className='detailGrid'>
                <div>
                    <span className='detailLabel'>날씨</span>
                    <span className='detailValue'>{WEATHER_LABELS[weather] || weather}</span>
                </div>
                <div>
                    <span className='detailLabel'>기온</span>
                    <span className='detailValue'>{temp}°</span>
                </div>
                <div>
                    <span className='detailLabel'>체감온도</span>
                    <span className='detailValue'>{windChill}°</span>
                </div>
                <div>
                    <span className='detailLabel'>습도</span>
                    <span className='detailValue'>{humidity}%</span>
                </div>
                <div>
                    <span className='detailLabel'>풍속</span>
                    <span className='detailValue'>{windSpeed}m/s</span>
                </div>
                <div>
                    <span className='detailLabel'>강수확률</span>
                    <span className='detailValue'>{rainRate}%</span>
                </div>
                {precipitation ? <div>
                    <span className='detailLabel'>강수량</span>
                    <span className='detailValue'>{precipitation}</span>
                </div> : null}
            </div>
        </div>
    );
};

export default WeatherDetail;
